<template>
  <!-- 分页 -->
  <div class="pagination-container">
    <!-- layout="total, prev, pager, next, sizes" -->
    <!-- @size-change="handleSizeChange" -->
    <el-pagination
      :current-page="currentPage"
      :page-size="pageSize"
      :pager-count="_isMobile?5:7"
      :small="_isMobile?true:false"
      :total="Number(total)"
      background
      layout="total, prev, pager, next"
      @current-change="handleCurrentChange"
      v-show="Number(total)>pageSize"
    />
  </div>
</template>

<script>
export default {
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: String,
      default: '0'
    },
  },
  // watch: {
  //   $route: {
  //     handler(Val) {
  //       return this.getBreadcrumb()
  //     },
  //     immediate: true
  //   },
  //   '$store.state.app.breadcumbList': function(newVal) {
  //     if(this.$route.meta.useStore) {
  //       this.breadList = newVal
  //     }
  //   }
  // },
  data() {
    return {
      // currentPage: 1
    }
  },
  methods: {
    // handleSizeChange(val) {
    //   this.pageSize = val
    //   this.$emit('eventPage', {
    //     currentPage: this.currentPage,
    //     size: this.pageSize
    //   })
    // },
    handleCurrentChange(val) {
      this.$emit('eventPage', {
        page: val,
        size: this.pageSize
      })
      window.scrollTo({
        top: 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination-container {
  text-align: center;
  /deep/ .el-pagination {
    .el-pagination__editor.el-input .el-input__inner {
      border-radius: 20px;
      border-color: $primary;
    }
  }
}
</style>
